/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SecurityDefinitions } from '../../openapi/v2/models/Oas20SecurityDefinitions';
import { Oas20SecurityScheme } from '../../openapi/v2/models/Oas20SecurityScheme';
import { DeleteSecuritySchemeCommand } from './DeleteSecuritySchemeCommand';
import { Node } from '../../core/models/Node';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteSecuritySchemeCommand
 * @class
 */
export class DeleteSecuritySchemeCommand_20 extends DeleteSecuritySchemeCommand {
    public constructor(schemeName? : any) {
        if(((typeof schemeName === 'string') || schemeName === null)) {
            let __args = arguments;
            super(schemeName);
        } else if(schemeName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand#doDeleteScheme(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteScheme(document : Document) : any {
        let doc20 : Oas20Document = <Oas20Document>document;
        let definitions : Oas20SecurityDefinitions = doc20.securityDefinitions;
        if(this.isNullOrUndefined(definitions)) {
            return null;
        }
        return Library.writeNode(definitions.removeSecurityScheme(this._schemeName));
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand#doRestoreScheme(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} document
     * @param {*} oldScheme
     */
    doRestoreScheme(document : Document, oldScheme : any) {
        let doc20 : Oas20Document = <Oas20Document>document;
        let definitions : Oas20SecurityDefinitions = doc20.securityDefinitions;
        if(this.isNullOrUndefined(definitions) || this.isNullOrUndefined(oldScheme)) {
            return;
        }
        let scheme : Oas20SecurityScheme = definitions.createSecurityScheme(this._schemeName);
        Library.readNode(oldScheme, scheme);
        definitions.addSecurityScheme(this._schemeName, scheme);
    }
}
DeleteSecuritySchemeCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand_20";
DeleteSecuritySchemeCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




